import React from "react";
import { styled, Typography } from "@mui/material";
import { convertPxToRem } from "@treez-inc/component-library";

interface ErrorTileProps {
  errorMessage: string;
}

const ErrorTileWrapper = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.error.light,
  borderRadius: convertPxToRem(15),
  padding: convertPxToRem(20),
  marginBottom: convertPxToRem(23),
}));

const ErrorTile: React.FC<ErrorTileProps> = ({ errorMessage }) => (
  <ErrorTileWrapper data-testid="error-tile">
    <Typography variant="mediumText">{errorMessage}</Typography>
  </ErrorTileWrapper>
);

export default ErrorTile;
